@if (url) {
<div class="video-container" ngxOnHover [ngStyle]="{ height: options.height, width: options.width }">
    <video #videoPlayer [width]="options.width" [height]="options.height" (click)="actionOnVideo()"
        (loadeddata)="onDataLoaded()" [volume]="0" crossorigin="anonymous">
        <source [src]="url" type="video/mp4" />
    </video>
    @if (videoLoaded && showActions && !nocontrols) {
    <div class="screen-actions flex-center" (click)="actionOnVideo(true)">
        <mat-icon>{{
            vp.nativeElement.ended ? 'replay' : 'play_arrow'
            }}</mat-icon>
    </div>
    }
    @if (videoLoaded && !nocontrols) {
    <ngx-video-controls [class.active]="onHover || showActions" [target]="vp" (stateChange)="actionOnVideo($event)"
        (pbOnHover)="onPbHovered($event)" [thumb]="thumb" (duration)="setDuration($event)"
        (nonControlAreaClicked)="actionOnVideo()" [thumbnailRatio]="options.thumbnailRatio || 5"></ngx-video-controls>
    }
</div>
}